module.exports = __webpack_public_path__ + "static/media/alert-border-line.9b840cef.svg";